import { PORTAL_IMAGE } from "constants/imagePath";

export const IMPROVE_DESTINATIONS = {
    PROGRAMS: {
        HEALTHY_HEART: "healthy-heart",
        SLEEP: "better-sleep",
        STRESS: "building-stress-resilience",
        WEIGHT_LOSS: "sustainable-weight-loss",
        PERSONAL_PRODUCTIVITY: "personal-productivity",
        SEVEN_MIN_WORKOUT: "the-7-minute-workout"
    }
};

// The meal and activity planners have been switched off. Old links to them (bookmarks, emails)
// still arrive as `?wants=...`, so they land on the Improve page instead of launching.
export const RETIRED_DESTINATIONS = ["meals", "activity_planner"];

export const USES_LEARN_WORLD = {
    "healthy-heart": "heartHealth",
    "better-sleep": "sleep",
    "building-stress-resilience": "buildingStressResilience",
    "sustainable-weight-loss": "sustainableWeightLoss",
    "the-7-minute-workout": "sevenMinuteWorkout"
};

export const PLAN_SEVEN_MIN_WORKOUT = {
    type: "PLAN_SEVEN_MIN_WORKOUT",
    title: "members_portal_web.views.improve.plans.titles.seven_min_workout",
    text: "members_portal_web.views.improve.plans.texts.seven_min_workout",
    image: `${PORTAL_IMAGE}/improve/seven-minute-workout.svg`,
    usesLearnWorld: true,
    link: IMPROVE_DESTINATIONS.PROGRAMS.SEVEN_MIN_WORKOUT,
    isPremOnlyCard: true
};

export const PLAN_HEALTHY_HEART = {
    type: "PLAN_HEALTHY_HEART",
    title: "members_portal_web.views.improve.plans.titles.healthy_heart",
    text: "members_portal_web.views.improve.plans.texts.healthy_heart",
    image: `${PORTAL_IMAGE}/improve/heart_age.svg`,
    usesLearnWorld: true,
    link: IMPROVE_DESTINATIONS.PROGRAMS.HEALTHY_HEART,
    isPremOnlyCard: true
};

export const PLAN_SUSTAINABLE_WEIGHT_LOSS = {
    type: "PLAN_SUSTAINABLE_WEIGHT_LOSS",
    title: "members_portal_web.views.improve.plans.titles.weight_loss",
    text: "members_portal_web.views.improve.plans.texts.weight_loss",
    image: `${PORTAL_IMAGE}/improve/sustainable-weight.svg`,
    usesLearnWorld: true,
    link: IMPROVE_DESTINATIONS.PROGRAMS.WEIGHT_LOSS,
    isPremOnlyCard: true
};

export const PLAN_BETTER_SLEEP = {
    type: "PLAN_BETTER_SLEEP",
    title: "members_portal_web.views.improve.plans.titles.better_sleep",
    text: "members_portal_web.views.improve.plans.texts.better_sleep",
    image: `${PORTAL_IMAGE}/improve/sleep.svg`,
    usesLearnWorld: true,
    link: IMPROVE_DESTINATIONS.PROGRAMS.SLEEP,
    isPremOnlyCard: true
};

export const PLAN_BUILDING_STRESS_RESILIENCE = {
    type: "PLAN_BUILDING_STRESS_RESILIENCE",
    title: "members_portal_web.views.improve.plans.titles.stress_resilience",
    text: "members_portal_web.views.improve.plans.texts.stress_resilience",
    image: `${PORTAL_IMAGE}/improve/stress.svg`,
    link: IMPROVE_DESTINATIONS.PROGRAMS.STRESS,
    isPremOnlyCard: true
};

export const IMPROVE_DATA = [
    PLAN_SEVEN_MIN_WORKOUT,
    PLAN_HEALTHY_HEART,
    PLAN_BETTER_SLEEP,
    PLAN_SUSTAINABLE_WEIGHT_LOSS,
    PLAN_BUILDING_STRESS_RESILIENCE
];
